import React, { useCallback, useState } from "react";
import { Box, Flex, Link, LoadingSpinner, SecureTickIcon, Span, StarRating, Text, TextButton } from "@catchoftheday/cg-components";
import { MetaTags } from "@catchoftheday/common-vendors";
import { logIn, LOGIN_URL } from "@catchoftheday/customer";
import { useTheme } from "@catchoftheday/theme";
import { date as dateUtils } from "@catchoftheday/utilities";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ReviewItem = function ReviewItem(_ref) {
  var reviewId = _ref.id,
      comment = _ref.comment,
      date = _ref.date,
      helpful = _ref.helpful,
      rating = _ref.rating,
      firstName = _ref.firstName,
      customerOwnsReview = _ref.customerOwnsReview,
      onClickHelpful = _ref.onClickHelpful;

  var _useState = useState(helpful),
      helpfulReviews = _useState[0],
      setHelpfulReviews = _useState[1];

  var _useState2 = useState(false),
      requiresAuth = _useState2[0],
      setRequiresAuth = _useState2[1];

  var _useState3 = useState(false),
      loading = _useState3[0],
      setLoading = _useState3[1];

  var handleUpdate = useCallback(function (helpfulCountAdjustment) {
    onClickHelpful(reviewId, helpfulCountAdjustment, setRequiresAuth, setHelpfulReviews, setLoading);
  }, [onClickHelpful, reviewId]);

  var _useTheme = useTheme(),
      _useTheme$colors = _useTheme.colors,
      backgroundColor = _useTheme$colors.ui.backgroundColor,
      primary = _useTheme$colors.primary,
      space = _useTheme.space;

  return ___EmotionJSX(Flex, {
    itemType: "http://schema.org/Review",
    itemProp: "review",
    itemScope: true
  }, ___EmotionJSX(Box, {
    flexGrow: 1
  }, ___EmotionJSX(Flex, {
    justifyContent: "space-between",
    itemProp: "reviewRating",
    itemType: "http://schema.org/Rating",
    itemScope: true,
    mb: 2
  }, ___EmotionJSX(StarRating, {
    rating: rating,
    backgroundColour: backgroundColor,
    width: 88
  }), ___EmotionJSX(MetaTags, {
    tags: [{
      itemProp: "worstRating",
      content: "1"
    }, {
      itemProp: "ratingValue",
      content: "".concat(rating)
    }, {
      itemProp: "bestRating",
      content: "5"
    }]
  })), ___EmotionJSX(Flex, {
    itemProp: "author",
    itemType: "https://schema.org/Person",
    itemScope: true,
    gap: 2
  }, ___EmotionJSX(MetaTags, {
    tags: [{
      itemProp: "name",
      content: firstName !== null && firstName !== void 0 ? firstName : ""
    }]
  }), ___EmotionJSX(Text, {
    m: 0,
    fontWeight: "semibold"
  }, firstName), ___EmotionJSX(Text, {
    m: 0,
    color: "typography.subText"
  }, date, ___EmotionJSX(MetaTags, {
    tags: [{
      itemProp: "datePublished",
      content: dateUtils.format(date, "yyyy-MM-dd")
    }]
  }))), comment && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Text, {
    itemProp: "description",
    my: 2
  }, comment), ___EmotionJSX(Flex, {
    alignItems: "center",
    mb: 2
  }, ___EmotionJSX(SecureTickIcon, {
    style: {
      color: primary,
      width: "16px",
      height: "16px",
      marginRight: space[1]
    }
  }), ___EmotionJSX(Text, {
    color: "typography.subText",
    m: 0
  }, "Verified Purchase")), helpfulReviews.totalCount > 0 && ___EmotionJSX(Text, {
    fontWeight: "semibold"
  }, helpfulReviews.positiveCount == 1 && helpfulReviews.totalCount == 1 ? "1 customer found this helpful" : "".concat(helpfulReviews.positiveCount, " out of ").concat(helpfulReviews.totalCount, " customers found this helpful")), !customerOwnsReview && ___EmotionJSX(Flex, {
    mb: 0
  }, ___EmotionJSX(Span, {
    fontWeight: "semibold",
    mr: "5px"
  }, "Was this helpful?"), !helpfulReviews.customerHelpfulFeedback ? ___EmotionJSX(Span, null, ___EmotionJSX(TextButton, {
    onClick: function onClick() {
      return handleUpdate(1);
    }
  }, "Yes"), " | ", ___EmotionJSX(TextButton, {
    onClick: function onClick() {
      return handleUpdate(-1);
    }
  }, "No")) : ___EmotionJSX(Span, null, helpfulReviews.customerHelpfulFeedback < 0 ? "No" : "Yes", " | ", ___EmotionJSX(TextButton, {
    onClick: function onClick() {
      return handleUpdate(0);
    }
  }, "Cancel")), loading && ___EmotionJSX(LoadingSpinner, {
    width: "20px",
    height: "20px",
    ringSize: "2px",
    ml: "5px"
  })), comment && requiresAuth && ___EmotionJSX(Text, {
    m: "0"
  }, "You must", " ", ___EmotionJSX(Link, {
    href: LOGIN_URL,
    onClick: function onClick(e) {
      e.preventDefault();
      logIn({
        returnToSelf: true
      });
    }
  }, "login"), " ", "to rate this review."))));
};